module.exports = __webpack_public_path__ + "assets/img/img-placeholder-reel-w1460.3b89885f.webp";